<div *ngIf="isLoading || hasError" class="eu-display_flex eu-justify_center eu-align_center">
    <div *ngIf="isLoading && !hasError" class="spinner-border"></div>
    <div *ngIf="!isLoading && hasError">
        <p *ngIf="errorMessage !== ''">{{ errorMessage }}</p>
        <button (click)="emit()"><i class="fa fa-refresh fa-3x" aria-hidden="true"> </i></button>
        <p class="eu-mt_4">Tentar novamente</p>
    </div>
</div>
